import { ROUTES } from "const";
import { ReactComponent as ProductIcon } from "images/svg/copy.svg";
import { ReactComponent as PaymentIcon } from "images/svg/card.svg";
import { ReactComponent as SalesPersonIcon } from "images/svg/Salespersons.svg";
import { ReactComponent as PrinterIcon } from "images/svg/printer-grey.svg";
import { ReactComponent as SettingsIcon } from "images/svg/setting-2.svg";
import { ReactComponent as AboutUsIcon } from "images/svg/logo.svg";
import { ReactComponent as ServersIcon } from "images/svg/driver.svg";

const ManageNavConfig = [
  {
    id: "products",
    name: "Categories & Products",
    description: "Manage Products, Pricing, and Inventory",
    path: ROUTES.PRODUCTS,
    icon: ProductIcon,
  },
  {
    id: "servers",
    name: "Servers",
    // description: "Manage KOT, Label and Bluetooth scales",
    description: "Manage KOT",
    path: ROUTES.SERVERS,
    icon: ServersIcon,
  },

  {
    id: "payment-mode",
    name: "Payment Mode",
    description: "Manage and customise various payment options",
    path: ROUTES.PAYMENT_MODE,
    icon: PaymentIcon,
  },
  {
    id: "salesperson",
    name: "Salespersons",
    description: "Manage and track sales team performance",
    path: ROUTES.SALESPERSON,
    icon: SalesPersonIcon,
  },
  {
    id: "printers",
    name: "Printers",
    description: "Manage printer settings and configuration",
    path: ROUTES.PRINTERS,
    icon: PrinterIcon,
  },
  {
    id: "settings",
    name: "Settings",
    description: "Customise app preferences and configuration",
    icon: SettingsIcon,
    path: ROUTES.SETTINGS,
  },
  {
    id: "Sanoft-POS",
    name: "SanoftPOS",
    description: "Contact us for support",
    path: ROUTES.ABOUT_US,
    icon: AboutUsIcon,
  },
];

export default ManageNavConfig;
